import React from 'react'
import { Refine } from '@pankod/refine-core'
import routerProvider from '@pankod/refine-nextjs-router'
import { AppProps } from 'next/app'
import Router from 'next/router'
import NProgress from 'nprogress'

import { axiosInstance } from '@/api/Api'
import ErrorPage from '@/components/ErrorPage'
import HomePage from '@/components/home/HomePage'
import Layout from '@/components/layout/Layout'
import LoginPage from '@/components/LoginPage/LoginPage'
import { authProvider } from '@/lib/authProvider'
import { dataProvider } from '@/lib/dataProvider'

import '@/css/reset.css'
import '@/css/global.css'

Router.events.on('routeChangeStart', () => NProgress.start())
Router.events.on('routeChangeComplete', () => NProgress.done())
Router.events.on('routeChangeError', () => NProgress.done())

function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  return (
    <Refine
      routerProvider={routerProvider}
      dataProvider={dataProvider(axiosInstance)}
      options={{ syncWithLocation: true }}
      DashboardPage={HomePage}
      LoginPage={LoginPage}
      resources={[{ name: 'dashboard' }, { name: 'provenance' }]}
      authProvider={authProvider(axiosInstance)}
      Layout={Layout}
      catchAll={<ErrorPage />}
    >
      <Component {...pageProps} />
    </Refine>
  )
}

export default MyApp
